(function(){
    'use strict'

    angular
    .module('app.turnos')
    .controller('EditarTurno', EditarTurno);

    EditarTurno.$inject = ['$q', '$scope', '$animationsSrv', '$routeParams','TurnosService', 'logger', '$location', 'ArchivoCCSSService'];

    function EditarTurno($q, $scope, $animationsSrv, $routeParams, TurnosService, logger, $location, ArchivoCCSSService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        vm.tiposJornada = [];

        vm.turnoId = $routeParams.id ? $routeParams.id : 0;

        vm.turno = {
            tipoJornada: 'indefinido'
        };

        var promiseTipoJornada = getTipoJornada();

        getTurno();

        function getTipoJornada(){
            var promise = ArchivoCCSSService.getTiposJornada()
            .then(function(tiposJornada){
                vm.tiposJornada = tiposJornada;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de jornada.');
            }); 
            
            return promise;
        };

        function getTurno(){

            $q.all([getTipoJornada]).then(function(){
                if(vm.turnoId != 0){
                    var promise = TurnosService.getById(vm.turnoId);

                    promise
                    .then(function(turno){
                        vm.turno = turno;
                    })
                    .catch(function(error){
                        switch (error.status) {
                            case 401:
                                logger.error('La sesión ha expirado');
                                break;
                        
                            default:
                                logger.error('Hubo un error al obtener el turno: ' + error.data.Message);
                                break;
                        }
                    });               
                }                
            });
        };

        function doFormValidations(){
            validateTipoJornada();
        };

        vm.save = function(){

            $scope.submitted = true;
            
            doFormValidations();

            if($scope.turnoForm.$valid){
                if(!vm.turno.id){
                    saveTurno();
                }
                else if($scope.turnoForm.$dirty){
                    updateTurno();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function saveTurno() {
            var promise = TurnosService.save(vm.turno);
            
            promise
            .then(function(response){
                logger.success('Turno creado con éxito.');
                clearTurnoData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el turno: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updateTurno(){
            var promise = TurnosService.update(vm.turno);
            
            promise
            .then(function(response){
                logger.success('Turno modificado con éxito.');
                $location.path('/turnos');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el turno: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearTurnoData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.turno = {};
            // Set back to pristine.
            $scope.turnoForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.turnoForm.$setUntouched();
        };

        function validateTipoJornada(){
            if(!vm.turno.tipoJornada || vm.turno.tipoJornada == 'indefinido'){
                $scope.turnoForm.tipoJornada.$setValidity("different", false);
            }
            else{
                $scope.turnoForm.tipoJornada.$setValidity("different", true);
            }
        };
        
        vm.tipoJornadaChange = function(){
            validateTipoJornada();
        };

    }
})();